export const Endpoint = "chat/get-message";
export const Method = "POST";
export const RateLimitingConfig = {
    calls: 3,
    per: 750,
};
